module.exports = __webpack_public_path__ + "img/drop-down-up-arrow.3b6e0e34.svg";